export default [
  {
    path: "/login",
    name: "login",
    component: () => import("@/pages/login.vue"),
    meta: {
      title: "登录",
      displayable: false, //是否为可显示页面
      isUseCache: false, // 默认不缓存
      hideNav: true,
      keepAlive: true, // 是否使用 keep-alive
    },
  },
  {
    path: "/view404",
    name: "404",
    component: () => import("@/pages/view404.vue"),
    meta: {
      title: "404",
      displayable: false, //是否为可显示页面
      isUseCache: false, // 默认不缓存
      hideNav: true,
      keepAlive: true, // 是否使用 keep-alive
    },
  },
  {
    path: "/view403",
    name: "403",
    component: () => import("@/pages/view403.vue"),
    meta: {
      title: "403",
      displayable: false, //是否为可显示页面
      isUseCache: false, // 默认不缓存
      hideNav: true,
      keepAlive: true, // 是否使用 keep-alive
    },
  },
  {
    path: "/home",
    name: "home",
    component: () => import("@/pages/home.vue"),
    meta: {
      title: "用户管理",
      displayable: true, //是否为可显示页面
      isUseCache: false, // 默认不缓存
      keepAlive: true, // 是否使用 keep-alive约会审核管理
    },
  },
  {
    path: "/meet",
    name: "meet",
    component: () => import("@/pages/orderpointgood.vue"),
    meta: {
      title: "约会审核管理",
      displayable: true, //是否为可显示页面
      isUseCache: false, // 默认不缓存
      keepAlive: true, // 是否使用 keep-alive
    },
  },
  {
    path: "/activity",
    name: "activity",
    component: () => import("@/pages/activity.vue"),
    meta: {
      title: "约会审核管理",
      displayable: true, //是否为可显示页面
      isUseCache: false, // 默认不缓存
      keepAlive: true, // 是否使用 keep-alive
    },
  },
  {
    path: "/announcement",
    name: "announcement",
    component: () => import("@/pages/announcement.vue"),
    meta: {
      title: "约会审核管理",
      displayable: true, //是否为可显示页面
      isUseCache: false, // 默认不缓存
      keepAlive: true, // 是否使用 keep-alive
    },
  },
  {
    path: "/success",
    name: "success",
    component: () => import("@/pages/success.vue"),
    meta: {
      title: "成功案例",
      displayable: true, //是否为可显示页面
      isUseCache: false, // 默认不缓存
      keepAlive: true, // 是否使用 keep-alive
    },
  },
  {
    path: "/lbtgl",
    name: "lbtgl",
    component: () => import("@/pages/lbtgl.vue"),
    meta: {
      title: "轮播图管理",
      displayable: true, //是否为可显示页面
      isUseCache: false, // 默认不缓存
      keepAlive: true, // 是否使用 keep-alive
    },
  },
];
